/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable react/jsx-wrap-multilines */
import React, { useEffect } from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { submit } from 'redux-form';
import { useHistory, useLocation } from 'react-router';
import PropTypes from 'prop-types';
import { useInjectSaga } from '../../utils/injectSaga';
import saga from './saga';
import { useInjectReducer } from '../../utils/injectReducer';
import reducer from './reducer';
import { ModalWindow } from '../../semantic-ui/components/modal-window';
import ModalFooterButtons from '../../semantic-ui/components/modal-window/modal-footer-buttons';

import { getReqInfoAction, resetStateAction, sendFormAction } from './actions';
import {
	getActiveReqIdSelector,
	getIsReqInfoLoadingSelector,
	getIsModalShownSelector,
	getIsFormSendingSelector,
} from './selectors';
import { FORM_NAME } from './constants';
import { removeModalQuery } from '../../utils/removeModalQuery';
import { CargoFetchForm } from './components/cargo-fetch-form';

const CargoFetchWrapper = ({
	onGetReqInfo,
	isReqInfoLoading,
	isFormSending,
	onResetState,
	isModalShown,
	activeReqId,
	onFormSubmit,
	onSendForm,
}) => {
	if (!isModalShown) return null;
	useInjectSaga({ key: 'cargoFetchModalSaga', saga });
	useInjectReducer({ key: 'cargoFetchModalReducer', reducer });

	const { search, pathname } = useLocation();

	const query = new URLSearchParams(search);

	const history = useHistory();

	useEffect(() => {
		return () => onResetState();
	}, []);

	useEffect(() => {
		if (activeReqId) onGetReqInfo(activeReqId);
	}, [activeReqId]);

	const handleModalClose = () => {
		query.delete('modal');
		query.delete('mode');
		query.delete('id');
		query.delete('tab');

		onResetState();
		history.push(`${pathname}?${query}`);
	};

	const handleFormSubmit = async () => {
		await onFormSubmit(FORM_NAME);
		onSendForm({
			redirect: handleModalClose,
			id: activeReqId,
			searchQuery: removeModalQuery(query.toString()),
		});
	};

	const handleKeyDown = e => {
		if (e.key === 'Enter' && e.shiftKey === false) {
			handleFormSubmit();
		}
	};

	return (
		<ModalWindow
			isModalShown={isModalShown}
			onKeyDown={handleKeyDown}
			onClose={handleModalClose}
			headerText="Форма забора груза"
			navItems={[]}
			modalContent={<CargoFetchForm />}
			style={{ width: '895px' }}
			actionButtons={[{ type: 'close', onClick: handleModalClose, text: 'cargo-fetch' }]}
			footerButtons={
				<ModalFooterButtons
					leftButtons={[]}
					rightButtons={[
						{
							onClick: () => handleFormSubmit(),
							text: 'Груз забран',
							color: 'primary',
							disabled: isReqInfoLoading || isFormSending,
							loading: isFormSending,
						},
						{
							onClick: handleModalClose,
							text: 'Закрыть',
							color: 'secondary',
							disabled: isFormSending,
						},
					]}
				/>
			}
		/>
	);
};

const mapStateToProps = createStructuredSelector({
	isReqInfoLoading: getIsReqInfoLoadingSelector(),
	isFormSending: getIsFormSendingSelector(),
	isModalShown: getIsModalShownSelector(),
	activeReqId: getActiveReqIdSelector(),
});

const mapDispatchToProps = {
	onGetReqInfo: getReqInfoAction,
	onResetState: resetStateAction,
	onFormSubmit: submit,
	onSendForm: sendFormAction,
};

const CargoFetchModal = connect(mapStateToProps, mapDispatchToProps)(CargoFetchWrapper);

CargoFetchWrapper.propTypes = {
	onGetReqInfo: PropTypes.func.isRequired,
	isReqInfoLoading: PropTypes.bool.isRequired,
	isFormSending: PropTypes.bool.isRequired,
	onResetState: PropTypes.func.isRequired,
	isModalShown: PropTypes.bool.isRequired,
	activeReqId: PropTypes.string,
	onFormSubmit: PropTypes.func.isRequired,
	onSendForm: PropTypes.func.isRequired,
};

export default CargoFetchModal;
